<template>
  <div id="attendance" class="card-custom ">
    <b-row>
      <b-col md="12">
        <a class="navigation-text text-center">Revenue & Cost {{ year }}</a>
        <apexchart
          type="line"
          height="240"
          width="100%"
          :options="chartOptions"
          :series="series"
        ></apexchart>
        <!-- <apexchart type="bar" height="220" width="90%" :options="chartOptions" :series="series"></apexchart> -->
      </b-col>
      <!-- <b-col>
        <apexchart
          type="pie"
          width="300"
          height="300"
          :options="chartOptionsChart"
          :series="seriesChart"
          class="mt-5 float-right"
        ></apexchart>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import DatePicker from 'vue2-datepicker';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
export default {
  name: 'pie-attendance',
  components: { DatePicker },
  data() {
    const dataAccount = this.$store.getters['account/accountData'];
    const yearly = new Date().getFullYear();
    let format = dataAccount.account !== undefined ? dataAccount.account.currency : 'RM';

    return {
      apiUrl: {
        salesChart: window.AppConfig.apiUrl + 'new-dashboard',
      },
      selected: [],
      year: yearly,
      filter: {
        // month: monthly,
        year: null,
      },
      text: '',
      show: false,
      salesData: [],
      series: [],

      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },

          zoom: {
            enabled: true,
          },
        },

        plotOptions: {
          bar: {
            columnWidth: '35%',
            horizontal: false,
          },
        },

        dataLabels: {
          enabled: false,
        },
        sparkline: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          curve: 'smooth',
        },
        xaxis: {
          crosshairs: {
            width: 1,
          },
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },

        yaxis: {
          title: {
            text: `Revenue (${format})`,
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              let val1 = (val / 1).toFixed(2).replace(',', '.');
              let money = val1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              return format + ' ' + money;
            },
          },
        },
      },
    };
  },

  mounted() {
    this.getSalesData();
  },

  methods: {
    getSalesData() {
      this.$http.get(this.apiUrl.salesChart + '?sales_year=' + this.year).then((resp) => {
        this.salesData = resp.data.sales;
        this.series = [
          {
            name: 'Revenue',
            type: 'bar',
            data: [
              this.salesData.Jan.totalIncome !== null ? this.salesData.Jan.totalIncome : 0,
              this.salesData.Feb.totalIncome !== null ? this.salesData.Feb.totalIncome : 0,
              this.salesData.Mar.totalIncome !== null ? this.salesData.Mar.totalIncome : 0,
              this.salesData.Apr.totalIncome !== null ? this.salesData.Apr.totalIncome : 0,
              this.salesData.May.totalIncome !== null ? this.salesData.May.totalIncome : 0,
              this.salesData.Jun.totalIncome !== null ? this.salesData.Jun.totalIncome : 0,
              this.salesData.Jul.totalIncome !== null ? this.salesData.Jul.totalIncome : 0,
              this.salesData.Aug.totalIncome !== null ? this.salesData.Aug.totalIncome : 0,
              this.salesData.Sep.totalIncome !== null ? this.salesData.Sep.totalIncome : 0,
              this.salesData.Oct.totalIncome !== null ? this.salesData.Oct.totalIncome : 0,
              this.salesData.Nov.totalIncome !== null ? this.salesData.Nov.totalIncome : 0,
              this.salesData.Dec.totalIncome !== null ? this.salesData.Dec.totalIncome : 0,
            ],
          },
          {
            name: 'Credit',
            type: 'bar',
            data: [
              this.salesData.Jan.totalCredit !== null ? this.salesData.Jan.totalCredit : 0,
              this.salesData.Feb.totalCredit !== null ? this.salesData.Feb.totalCredit : 0,
              this.salesData.Mar.totalCredit !== null ? this.salesData.Mar.totalCredit : 0,
              this.salesData.Apr.totalCredit !== null ? this.salesData.Apr.totalCredit : 0,
              this.salesData.May.totalCredit !== null ? this.salesData.May.totalCredit : 0,
              this.salesData.Jun.totalCredit !== null ? this.salesData.Jun.totalCredit : 0,
              this.salesData.Jul.totalCredit !== null ? this.salesData.Jul.totalCredit : 0,
              this.salesData.Aug.totalCredit !== null ? this.salesData.Aug.totalCredit : 0,
              this.salesData.Sep.totalCredit !== null ? this.salesData.Sep.totalCredit : 0,
              this.salesData.Oct.totalCredit !== null ? this.salesData.Oct.totalCredit : 0,
              this.salesData.Nov.totalCredit !== null ? this.salesData.Nov.totalCredit : 0,
              this.salesData.Dec.totalCredit !== null ? this.salesData.Dec.totalCredit : 0,
            ],
          },
          {
            name: 'COGS',
            type: 'bar',
            data: [
              this.salesData.Jan.totalCogs !== null ? this.salesData.Jan.totalCogs : 0,
              this.salesData.Feb.totalCogs !== null ? this.salesData.Feb.totalCogs : 0,
              this.salesData.Mar.totalCogs !== null ? this.salesData.Mar.totalCogs : 0,
              this.salesData.Apr.totalCogs !== null ? this.salesData.Apr.totalCogs : 0,
              this.salesData.May.totalCogs !== null ? this.salesData.May.totalCogs : 0,
              this.salesData.Jun.totalCogs !== null ? this.salesData.Jun.totalCogs : 0,
              this.salesData.Jul.totalCogs !== null ? this.salesData.Jul.totalCogs : 0,
              this.salesData.Aug.totalCogs !== null ? this.salesData.Aug.totalCogs : 0,
              this.salesData.Sep.totalCogs !== null ? this.salesData.Sep.totalCogs : 0,
              this.salesData.Oct.totalCogs !== null ? this.salesData.Oct.totalCogs : 0,
              this.salesData.Nov.totalCogs !== null ? this.salesData.Nov.totalCogs : 0,
              this.salesData.Dec.totalCogs !== null ? this.salesData.Dec.totalCogs : 0,
            ],
          },
          {
            name: 'Cost',
            type: 'bar',
            data: [
              this.salesData.Jan.totalCost !== null ? this.salesData.Jan.totalCost : 0,
              this.salesData.Feb.totalCost !== null ? this.salesData.Feb.totalCost : 0,
              this.salesData.Mar.totalCost !== null ? this.salesData.Mar.totalCost : 0,
              this.salesData.Apr.totalCost !== null ? this.salesData.Apr.totalCost : 0,
              this.salesData.May.totalCost !== null ? this.salesData.May.totalCost : 0,
              this.salesData.Jun.totalCost !== null ? this.salesData.Jun.totalCost : 0,
              this.salesData.Jul.totalCost !== null ? this.salesData.Jul.totalCost : 0,
              this.salesData.Aug.totalCost !== null ? this.salesData.Aug.totalCost : 0,
              this.salesData.Sep.totalCost !== null ? this.salesData.Sep.totalCost : 0,
              this.salesData.Oct.totalCost !== null ? this.salesData.Oct.totalCost : 0,
              this.salesData.Nov.totalCost !== null ? this.salesData.Nov.totalCost : 0,
              this.salesData.Dec.totalCost !== null ? this.salesData.Dec.totalCost : 0,
            ],
          },
        ];
      });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style lang="scss">
#attendance {
  height: 40vh;
}
.chart-position {
  top: -78px;
  display: grid;
  position: static;
  bottom: 20px;
  left: 21px;
}

.chart-position-2 {
  top: -198px;
  display: grid;
  position: static;
  bottom: 20px;
  left: 21px;
}
title {
  z-index: 1000;
}
ul,
li,
a {
  text-decoration: none !important;
}
.header {
  padding: 2rem 5rem 2rem 5rem;
  &__nav {
    position: relative;
  }
  &__navbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &__item {
    padding: 1rem;
  }
  &--icon {
    width: 1.65rem;
    height: 1.65rem;
  }
  &--button {
    top: 0;
    right: 0;
    position: absolute;
    margin: 0;
    padding: 0;
    color: gray;
    cursor: pointer;
    border: 1px solid transparent;
    background-color: transparent;
    &:focus {
      outline: 0;
    }
  }
}
// Dropdown Menu

.dropdown__menu {
  right: 15%;
  top: 0;
  position: absolute;
  z-index: 10;
  height: 100%;
  min-width: 300px;
  //   margin-top: 0.5rem;
  overflow-y: auto;
  padding: 1rem 1rem 2rem 0rem;
  border-radius: 12px;
  background-color: white !important;
  //   background: #fff !important;
  border: 1px solid var(--color-gray);
  background-clip: padding-box;
  &-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.6);
    padding: 0.8rem 0 0.8rem 2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0 50px 50px 0;
    &:hover {
      color: #17bf63;
      background-color: rgba(79, 192, 141, 0.1);
    }
  }
  &-svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &-text {
    font-weight: 300;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

// Animation Menu Icon

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

// Dropdown Menu Animation

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 1s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
